import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useTyreReplacementDeleteMutation = () =>
  useTypedMutation({
    mutationFn: (vehicle_tyre_replacement_id: number) => ApiInstance.post("/vehicle_tyre_replacements/delete", { vehicle_tyre_replacement_id }, ENV.appointmentBaseURL),
    onSuccess: vehicle_tyre_replacement_id => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.car?.tyres?.length) return;

      const tyreIdx = appointment.car.tyres.findIndex(t => t.replacements?.some(r => r.id === vehicle_tyre_replacement_id));
      if (tyreIdx < 0 || !appointment.car.tyres[tyreIdx].replacements?.length) return;

      const replacements = appointment.car.tyres[tyreIdx].replacements;
      let replacementIdx = replacements.findIndex(r => r.id === vehicle_tyre_replacement_id);
      if (replacementIdx < 0) return;

      const updatedAppointment = {
        ...appointment,
        car: {
          ...appointment.car,
          tyres: appointment.car.tyres.with(tyreIdx, { ...appointment.car.tyres[tyreIdx], replacements: replacements.toSpliced(replacementIdx, 1) })
        }
      };

      if (updatedAppointment.interventions?.length) {
        const interventionIdx = updatedAppointment.interventions.findIndex(i => i.replacements?.some(r => r.id === vehicle_tyre_replacement_id));

        if (interventionIdx > -1 && updatedAppointment.interventions[interventionIdx].replacements?.length) {
          replacementIdx = updatedAppointment.interventions[interventionIdx].replacements.findIndex(r => r.id === vehicle_tyre_replacement_id);

          if (replacementIdx > -1) {
            updatedAppointment.interventions = updatedAppointment.interventions.with(interventionIdx, {
              ...updatedAppointment.interventions[interventionIdx],
              replacements: updatedAppointment.interventions[interventionIdx].replacements.toSpliced(replacementIdx, 1)
            });
          }
        }
      }

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, updatedAppointment);
    }
  });
